import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import GuruSection from "@/components/GuruSection";
import CoursesSection from "@/components/CoursesSection";
import GallerySection from "@/components/GallerySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import EnquirySection from "@/components/EnquirySection";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function HomePage() {
  const [courses, setCourses] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [coursesRes, testimonialsRes, galleryRes] = await Promise.all([
          axios.get(`${API}/courses`),
          axios.get(`${API}/testimonials`),
          axios.get(`${API}/gallery`)
        ]);
        
        setCourses(coursesRes.data);
        setTestimonials(testimonialsRes.data);
        setGallery(galleryRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="home-page">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <GuruSection />
        <CoursesSection courses={courses} loading={loading} />
        <GallerySection images={gallery} loading={loading} />
        <TestimonialsSection testimonials={testimonials} loading={loading} />
        <EnquirySection />
      </main>
      <Footer />
    </div>
  );
}
